import ajax from "./ajax";


export function getJobs(params = '') {
  return ajax(`/Job/GetAllJobs?sort=-id&per-page=100${params}`);
}
export function getSingleJob(id) {
  return ajax(`/Job/GetJobById/${id}`);
}

export function createJob(data) {
  return ajax(`/Job/CreateJob`, { method: "POST", data });
}
export function updateJobdetails(id, data) {
  return ajax(`/Job/UpdateJobById/${id}`, { method: "PUT", data });
}

export function updateJob(id, data) {
  return ajax(`/Job/${id}/change-status`, { method: "PUT", data });
}
